<template>
    <div>
        <el-drawer
            title="商品排序"
            :visible.sync="drawerShow"
            :wrapperClosable="false"
            :destroy-on-close="true"
            size="auto"
            @close="close"
        >
            <div class="drawer-content">
                <template v-if="formData && formData.id">
                    <table class="info-table" width="100%">
                        <tr><th>商品</th><td>{{formData.name}}</td></tr>
                        <tr><th>当前序号</th><td>{{sort}}</td></tr>
                    </table>
                    <el-form
                        :model="formData"
                        :rules="rules"
                        ref="formData"
                        label-position="top"
                        class="MT20"
                    >
                        <el-form-item prop="sort" label="最新序号:">
                            <!-- <el-input
                                v-model="formData.sort"
                                placeholder="请输入最新序号"
                                type="number"
                                size="medium"
                            ></el-input> -->
                            <el-input-number style="width:100%" v-model="formData.sort" :precision="0" controls-position="right" :min="1" :max="99999999" size="medium" placeholder="请输入最新序号"></el-input-number>
                        </el-form-item>
                    </el-form>
                </template>
            </div>
            <div class="drawer-footer">
                <el-button size="medium" @click="close">取消</el-button>
                <el-button type="primary" size="medium" @click="submitForm" :loading="btnLoading">确定</el-button>
            </div>
        </el-drawer>
    </div>
</template>

<script>
export default {
    data(){
        return{
            drawerShow: false,
            btnLoading:false,
            sort:0,
            formData:{
                sort:0
            },
            rules:{
                sort:[{required: true,message:'请输入最新排序'}]
            }
        }
    },
    methods:{
        close(){
            this.$refs.formData.resetFields();
            this.drawerShow = false
        },
        show(obj){
            this.formData = {
                ...obj
            };
            this.sort = this.formData.sort;
            this.drawerShow = true
        },
        //表单提交
        submitForm() {
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true
                    this.$request({
                        url: '/shop_good/updateSort',
                        params: {
                            id: this.formData.id,
                            sort: this.formData.sort
                        },
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                this.$emit('onUpdate');
                                this.close();
                            } else {
                                this.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            this.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                } else {
                    return false;
                }
            });
        },
    }
}
</script>

<style lang="scss" scoped>

</style>